import {
  TURNOSPACIENTE_ERROR,
  TURNOSPACIENTE_LOADING,
  TURNOSPACIENTE_SUCCESS,
  TURNOSPACIENTE_RESET,
  TURNOSPACIENTE_LISTAMULTIMEDIA,
  TURNOSPACIENTE_PLANKINESIO,
  TURNOSPACIENTE_CANCELARPLANKINESIO,
  TURNOSPACIENTE_RESET_CANCELARPLANKINESIO,
  TURNOSPACIENTE_LIMPIAR_PLANKINESIO,
  TURNOSPACIENTE_ESTADOVIDEOLLAMADA,
  TURNOSPACIENTE_ULTIMOTURNO,
  TURNOSPACIENTE_TIPOTURNO,
  TURNOSPACIENTE_TIPOTURNO_RESET,
  TURNOSPACIENTE_MATRICULAMEDICO,
  TURNOSPACIENTE_GUARDAR_MATRICULAMEDICO,
  TURNOSPACIENTE_PUT_MATRICULAMEDICO,
  TURNOSPACIENTE_LIMPIAR_MATRICULAMEDICO,
  TURNOSPACIENTE_DATOSMEDICO,
  TURNOSPACIENTE_PUT_DATOSMEDICO,
  TURNOSPACIENTE_LIMPIAR_DATOSMEDICO,
  TURNOSPACIENTE_CAMBIARESTADO,
  TURNOSPACIENTE_CAMBIARESTADO_RESET,
  TURNOSPACIENTE_TURNOSOLICITUD,
  TURNOSPACIENTE_RESET_TURNOSOLICITUD,
  TURNOSPACIENTE_SUBIDAORDEN_LOADING,
  TURNOSPACIENTE_SUBIDAORDEN_LOADING_RESET,
} from "../../ActionTypes";
import axiosInstance from "../../../../global/helpers/axiosInstance";
import axiosLogin from "../../../../global/helpers/axiosLogin";
import { parseBackendError } from "../../../../global/utils/errorHandler";

export const wsGetTurnosPaciente = (idPariente) => (dispatch) => {
  dispatch({
    type: TURNOSPACIENTE_LOADING,
  });

  axiosLogin().then((respuesta) => {
    respuesta
      .get(`/his/turnos/getxPaciente/${!idPariente ? "" : idPariente}`)
      .then((res) => {
        dispatch({
          type: TURNOSPACIENTE_SUCCESS,
          payload: res.data,
        });
      })
      .catch((err) => {
        let error = {
          detail: err.response
            ? err.response.data
            : "Error al contactar el server.",
          origen: "portal",
        };

        dispatch({
          type: TURNOSPACIENTE_ERROR,
          payload: error,
        });
      });
  });
};

export const wsGetListaMultimediaPaciente =
  (idTurno, idProtocolo, idPariente, nextStep) => (dispatch) => {
    dispatch({
      type: TURNOSPACIENTE_LOADING,
    });

    axiosLogin().then((respuesta) => {
      respuesta
        .get(
          `his/turnos/listaMultimedia/${!idTurno ? -1 : idTurno}/${
            !idProtocolo ? -1 : idProtocolo
          }/${!idPariente ? -1 : idPariente}`
        )
        .then((res) => {
          if (nextStep) nextStep(true, res.data);
          dispatch({
            type: TURNOSPACIENTE_LISTAMULTIMEDIA,
            payload: res.data,
          });
        })
        .catch((err) => {
          if (nextStep) nextStep(true);
          let error = {
            detail: err.response
              ? err.response.data
              : "Error al contactar el server.",
            origen: "portal",
          };

          dispatch({
            type: TURNOSPACIENTE_ERROR,
            payload: error,
          });
        });
    });
  };

export const limpiarListaMultimedia = () => (dispatch) => {
  dispatch({
    type: TURNOSPACIENTE_LISTAMULTIMEDIA,
    payload: null,
  });
};

export const wsGetPlanKinesio =
  (idturnoSesion, idPacFamiliar) => (dispatch) => {
    dispatch({
      type: TURNOSPACIENTE_LOADING,
    });

    axiosLogin().then((respuesta) => {
      respuesta
        .get(
          `his/turnos/turnosPacKin/${idturnoSesion}/${
            idPacFamiliar ? idPacFamiliar : -1
          }`
        )
        .then((res) => {
          dispatch({
            type: TURNOSPACIENTE_PLANKINESIO,
            payload: res.data,
          });
        })
        .catch((err) => {
          let error = {
            detail: err.response
              ? err.response.data
              : "Error al contactar el server.",
            origen: "portal",
          };

          dispatch({
            type: TURNOSPACIENTE_ERROR,
            payload: error,
          });
        });
    });
  };
/* export const wsGetPlanKinesio =
  (idturnoSesion, idPacFamiliar) => (dispatch) => {
    dispatch({
      type: TURNOSPACIENTE_LOADING,
    });

    axiosInstance().then((respuesta) => {
      respuesta
        .get(
          `/turnosPacKin/${idturnoSesion}/${
            !idPacFamiliar ? "" : idPacFamiliar
          }`
        )
        .then((res) => {
          dispatch({
            type: TURNOSPACIENTE_PLANKINESIO,
            payload: res.data,
          });
        })
        .catch((err) => {
          let error = {
            detail: err.response
              ? err.response.data
              : "Error al contactar el server.",
            origen: "portal",
          };

          dispatch({
            type: TURNOSPACIENTE_ERROR,
            payload: error,
          });
        });
    });
  }; */

export const wsGetMatriculaMedico =
  (matricula, data, idturno) => (dispatch) => {
    dispatch({
      type: TURNOSPACIENTE_LOADING,
    });

    axiosLogin().then((respuesta) => {
      respuesta
        .get(`/his/medico-solicitante/por-matricula/${matricula}`)
        .then((res) => {
          data = data.map((obj) => {
            if (idturno === obj.idturno) {
              return { ...obj, medSolicitanteDto: res.data };
            } else {
              return obj;
            }
          });
          dispatch({
            type: TURNOSPACIENTE_MATRICULAMEDICO,
            payload: data,
          });
        })
        .catch((err) => {
          const parsedError = parseBackendError(err);

          dispatch({
            type: TURNOSPACIENTE_ERROR,
            payload: parsedError,
          });
        });
    });
  };

export const wsSolicitarDatosMedico = (idMed, nextStep) => (dispatch) => {
  dispatch({
    type: TURNOSPACIENTE_LOADING,
  });
  axiosLogin().then((respuesta) => {
    respuesta
      .get(`/his/medico-solicitante/solicitar-datos/${idMed}`)
      .then((resp) => {
        dispatch({
          type: TURNOSPACIENTE_DATOSMEDICO,
          payload: resp.data,
        });
        if (nextStep) nextStep(true, resp.data);
      })
      .catch((err) => {
        dispatch({ type: TURNOSPACIENTE_ERROR, payload: err.data });
        if (nextStep) nextStep(false, err?.response?.data);
      });
  });
};

export const wsLimpiarMatriculaMedico = (data, idturno) => (dispatch) => {
  dispatch({
    type: TURNOSPACIENTE_MATRICULAMEDICO,
    payload: (data = data.map((obj) => {
      if (idturno === obj.idturno) {
        return { ...obj, medSolicitanteDto: null };
      } else {
        return obj;
      }
    })),
  });
};

export const guardarDatosMatricula = (matricula, nextStep) => (dispatch) => {
  dispatch({ type: TURNOSPACIENTE_LOADING });
  axiosLogin().then((respuesta) => {
    respuesta
      .get(`/his/medico-solicitante/por-matricula/${matricula}`)
      .then((resp) => {
        dispatch({
          type: TURNOSPACIENTE_GUARDAR_MATRICULAMEDICO,
          payload: resp.data,
        });
        if (nextStep) nextStep(true, resp.data);
      })
      .catch((err) => {
        const parsedError = parseBackendError(err);
        dispatch({ type: TURNOSPACIENTE_ERROR, payload: parsedError });
        if (nextStep) nextStep(false, parsedError);
      });
  });
};

export const wsPutMedicoSolicitante =
  (idturno, medSolicitante, idPacFamiliar, nextStep) => (dispatch) => {
    dispatch({
      type: TURNOSPACIENTE_LOADING,
    });
    axiosLogin().then((respuesta) => {
      respuesta
        .put(
          `/his/medico-solicitante/turno/matricula/${idturno}/${medSolicitante}/${
            !idPacFamiliar ? -1 : idPacFamiliar
          }`
        )

        .then((resp) => {
          dispatch({
            type: TURNOSPACIENTE_PUT_MATRICULAMEDICO,
            payload: resp.data,
          });
          if (nextStep) nextStep(true, resp.data);
        })
        .catch((err) => {
          dispatch({ type: TURNOSPACIENTE_ERROR, payload: err.data });
          if (nextStep) nextStep(false, err.response.data);
        });
    });
  };

export const wsEnviarDatosMedicoSolicitante =
  (idMed, dtoDatos, nextStep) => (dispatch) => {
    dispatch({
      type: TURNOSPACIENTE_LOADING,
    });
    axiosLogin().then((respuesta) => {
      respuesta
        .put(`/his/medico-solicitante/datos-por-paciente/${idMed}`, dtoDatos)
        .then((resp) => {
          dispatch({
            type: TURNOSPACIENTE_PUT_DATOSMEDICO,
            payload: resp.data,
          });
          if (nextStep) nextStep(true, resp.data);
        })
        .catch((err) => {
          dispatch({ type: TURNOSPACIENTE_ERROR, payload: err.data });
          if (nextStep) nextStep(false, err.response.data);
        });
    });
  };

export const wsPutMedicoSolicitanteLaboratorio =
  (idProtocolo, medSolicitante, idPacFamiliar) => (dispatch) => {
    dispatch({
      type: TURNOSPACIENTE_LOADING,
    });

    axiosLogin().then((respuesta) => {
      respuesta
        .put(
          `/his/medico-solicitante/laboratorio/matricula/${idProtocolo}/${medSolicitante}/${
            !idPacFamiliar ? -1 : idPacFamiliar
          }`
        )
        .then((res) => {
          dispatch({
            type: TURNOSPACIENTE_PUT_MATRICULAMEDICO,
            payload: res.data,
          });
        })
        .catch((err) => {
          let error = {
            detail: err.response
              ? err.response.data
              : "Error al contactar el server.",
          };

          dispatch({
            type: TURNOSPACIENTE_ERROR,
            payload: error,
          });
        });
    });
  };

export const cambioEstado = () => (dispatch) => {
  dispatch({
    type: TURNOSPACIENTE_CAMBIARESTADO,
  });
};

export const limpiarDatosMedico = () => (dispatch) => {
  dispatch({
    type: TURNOSPACIENTE_LIMPIAR_DATOSMEDICO,
  });
};

export const limpiarMatriculaMedico = () => (dispatch) => {
  dispatch({
    type: TURNOSPACIENTE_LIMPIAR_MATRICULAMEDICO,
  });
};

export const wsCambioEstadoVideoLlamada = (idturno, encuesta) => (dispatch) => {
  dispatch({
    type: TURNOSPACIENTE_LOADING,
  });

  axiosInstance().then((respuesta) => {
    respuesta
      .put(`/TurnoVideoLlamada/cambiarEstado/${idturno}`, encuesta)
      .then((res) => {
        dispatch({
          type: TURNOSPACIENTE_ESTADOVIDEOLLAMADA,
          payload: res.cambioEstado,
        });
      })
      .catch((err) => {
        let error = {
          detail: err.response
            ? err.response.data
            : "Error al contactar el server.",
        };

        dispatch({
          type: TURNOSPACIENTE_ERROR,
          payload: error,
        });
      });
  });
};

export const wsLlamadaAtendida = (idturno) => (dispatch) => {
  dispatch({
    type: TURNOSPACIENTE_LOADING,
  });

  axiosInstance().then((respuesta) => {
    respuesta
      .put(`/TurnoVideoLlamada/llamadaAtendida/${idturno}`)
      .then((res) => {
        dispatch({
          type: TURNOSPACIENTE_SUCCESS,
          payload: res.data,
        });
      })
      .catch((err) => {
        let error = {
          detail: err.response
            ? err.response.data
            : "Error al contactar el server.",
        };

        dispatch({
          type: TURNOSPACIENTE_ERROR,
          payload: error,
        });
      });
  });
};

export const guardarUltimoTurno = (dtoTurno) => (dispatch) => {
  dispatch({
    type: TURNOSPACIENTE_ULTIMOTURNO,
    payload: dtoTurno,
  });
};

export const guardarTipoTurno = (tipoTurno) => (dispatch) => {
  dispatch({
    type: TURNOSPACIENTE_TIPOTURNO,
    payload: tipoTurno,
  });
};

export const IdTurnoSolicitud = (idTurno) => (dispatch) => {
  dispatch({
    type: TURNOSPACIENTE_TURNOSOLICITUD,
    payload: idTurno,
  });
};
export const resetIdTurnoSolicitud = () => (dispatch) => {
  dispatch({
    type: TURNOSPACIENTE_RESET_TURNOSOLICITUD,
  });
};

export const limpiarCambioEstado = () => (dispatch) => {
  dispatch({
    type: TURNOSPACIENTE_CAMBIARESTADO_RESET,
  });
};

export const limpiarUltimoTurno = () => (dispatch) => {
  dispatch({
    type: TURNOSPACIENTE_ULTIMOTURNO,
    payload: null,
  });
};

export const limpiarTipoTurno = () => (dispatch) => {
  dispatch({
    type: TURNOSPACIENTE_TIPOTURNO_RESET,
    payload: null,
  });
};

export const limpiarPlanKinesio = () => (dispatch) => {
  dispatch({ type: TURNOSPACIENTE_LIMPIAR_PLANKINESIO });
};

export const resetTurnosPaciente = () => (dispatch) => {
  dispatch({
    type: TURNOSPACIENTE_RESET,
  });
};

export const cancelarKinesioFlag = () => (dispatch) => {
  dispatch({
    type: TURNOSPACIENTE_CANCELARPLANKINESIO,
  });
};

export const subidaOrdenLoadingFlg = () => (dispatch) => {
  dispatch({
    type: TURNOSPACIENTE_SUBIDAORDEN_LOADING,
  });
};

export const resetSubidaOrdenLoadingFlg = () => (dispatch) => {
  dispatch({
    type: TURNOSPACIENTE_SUBIDAORDEN_LOADING_RESET,
  });
};
export const resetKinesioFlag = () => (dispatch) => {
  dispatch({
    type: TURNOSPACIENTE_RESET_CANCELARPLANKINESIO,
  });
};
